var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=\xEC\x9E\x91\xEC\x84\xB1\xEC\xA4\x91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0001 6.6001C13.5071 6.6001 11.1161 7.59045 9.35329 9.35329C7.59045 11.1161 6.6001 13.5071 6.6001 16.0001C6.6001 17.2345 6.84324 18.4569 7.31563 19.5973C7.78802 20.7378 8.48042 21.774 9.35329 22.6469C10.2262 23.5198 11.2624 24.2122 12.4029 24.6846C13.5433 25.157 14.7657 25.4001 16.0001 25.4001C17.2345 25.4001 18.4569 25.157 19.5973 24.6846C20.7378 24.2122 21.774 23.5198 22.6469 22.6469C23.5198 21.774 24.2122 20.7378 24.6846 19.5973C25.157 18.4569 25.4001 17.2345 25.4001 16.0001C25.4001 13.5071 24.4097 11.1161 22.6469 9.35329C20.8841 7.59045 18.4931 6.6001 16.0001 6.6001ZM7.93908 7.93908C10.077 5.80117 12.9766 4.6001 16.0001 4.6001C19.0236 4.6001 21.9232 5.80117 24.0611 7.93908C26.199 10.077 27.4001 12.9766 27.4001 16.0001C27.4001 17.4972 27.1052 18.9796 26.5323 20.3627C25.9594 21.7458 25.1197 23.0025 24.0611 24.0611C23.0025 25.1197 21.7458 25.9594 20.3627 26.5323C18.9796 27.1052 17.4972 27.4001 16.0001 27.4001C14.503 27.4001 13.0206 27.1052 11.6375 26.5323C10.2544 25.9594 8.99767 25.1197 7.93908 24.0611C6.88049 23.0025 6.04077 21.7458 5.46787 20.3627C4.89497 18.9796 4.6001 17.4972 4.6001 16.0001C4.6001 12.9766 5.80117 10.077 7.93908 7.93908Z",
    fill: "#7966FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle_check.9287a16b6b91aa26545c46a5bcfd8e7c.svg";
export { ForwardRef as ReactComponent };